<template>
  <div v-html="richText">
  </div>
</template>

<script>
import AgreementApi from '@/api/agreement';
import STATUS from '@/constants/status';
import { AGREEMENT_TYPE_DESC } from '@/constants/agreement';
import { transformNumberToStr } from '@/util/filter';

export default {
  data() {
    return {
      /**
       * 1 - 美团充电宝合作协议之补充协议;
       * 2 - 美团充电宝主体变更补充协议;
       * 3 - 美团充电宝合作续签协议;
       * 后续可在@/constants/agreement AGREEMENT_TYPE中持续补充
       */
      agreementTypeId: -1,
      richText: '',
    };
  },
  created() {
    this.getAgreementTypeId();
    this.getPreviewInfo();
  },
  methods: {
    getAgreementTypeId() {
      const { typeId } = this.$route.params || {};

      this.agreementTypeId = Number(typeId);
    },

    async getPreviewInfo() {
      try {
        const previewAgreementApiName = AGREEMENT_TYPE_DESC[this.agreementTypeId].previewAgreementApiName || '';
        const previewAgreementApi = AgreementApi[previewAgreementApiName];
        const { respCode, code, data } = await previewAgreementApi() || {};

        const _responseCode = transformNumberToStr(respCode) || transformNumberToStr(code);

        if (Number(_responseCode) !== STATUS.SUCCESS) return;

        const { coopInfo } = data || {};

        this.richText = coopInfo;
      } catch (e) {
        console.log(e);
        console.error(`AgreementApi中 ${AGREEMENT_TYPE_DESC[this.agreementTypeId].previewAgreementApiName} api可能不存在`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
